var _line, _line2, _circle, _path, _circle2, _path2, _circle3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 40,
    viewBox: "0 0 360 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 21,
    x2: 161,
    y2: 21,
    stroke: "url(#paint0_linear_154_2053)",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 199,
    y1: 21,
    x2: 321,
    y2: 21,
    stroke: "#505050",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    fill: "#111111",
    stroke: "#00C13A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2424 14.3923V25H20.3259V16.2517H20.2638L17.7828 17.8367V16.0912L20.414 14.3923H22.2424Z",
    fill: "#00C13A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 20,
    r: 19,
    fill: "#111111",
    stroke: "#505050",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.367 25L176.361 23.6171L180.106 20.0069C181.178 18.9347 181.738 18.3028 181.743 17.4171C181.738 16.4227 180.956 15.8011 179.915 15.8011C178.827 15.8011 178.123 16.4848 178.128 17.5622H176.315C176.305 15.5525 177.812 14.2472 179.941 14.2472C182.1 14.2472 183.561 15.5421 183.566 17.3187C183.561 18.5204 182.986 19.489 180.899 21.4572L179.019 23.327V23.4047H183.727V25H176.367Z",
    fill: "#505050"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 20,
    r: 19,
    fill: "#111111",
    stroke: "#505050",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.995 25.145C337.732 25.145 336.116 23.9123 336.064 22.1202H337.991C338.037 22.98 338.887 23.5394 339.99 23.5394C341.161 23.5394 342.005 22.8971 342 21.9596C342.005 21.0014 341.181 20.3177 339.799 20.3177H338.856V18.8467H339.799C340.928 18.8467 341.715 18.22 341.715 17.2928C341.715 16.4019 341.042 15.8011 340.016 15.8011C339.011 15.8011 338.151 16.3605 338.115 17.2462H336.287C336.328 15.4696 337.944 14.2472 340.026 14.2472C342.171 14.2472 343.564 15.5628 343.554 17.184C343.564 18.3805 342.777 19.2352 341.611 19.4786V19.5615C343.113 19.7635 343.963 20.7217 343.953 22.058C343.963 23.845 342.29 25.145 339.995 25.145Z",
    fill: "#505050"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_154_2053",
    x1: 39,
    y1: 22.5,
    x2: 161,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C13A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#505050"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep);
export default __webpack_public_path__ + "static/media/Step.d180fb007f5309e7116dd5816c4ec617.svg";
export { ForwardRef as ReactComponent };